module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "theme-block"
  }, [(_vm.title) ? _c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "data",
    attrs: {
      "element-loading-text": _vm.$t('themeViewFormLoadingText'),
      "model": _vm.data,
      "enctype": "multipart/form-data",
      "id": "uploadform",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.data.file), function(item, id) {
    return (_vm.data.file) ? _c('el-form-item', {
      key: id,
      attrs: {
        "data-qa": ("Content-ThemeForm-Item-" + id),
        "label-width": _vm.labelWidth,
        "label": _vm.$t(item.label)
      }
    }, [_c('div', {
      staticClass: "image-block"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.currentImgSrc || !item.isLocal),
        expression: "item.currentImgSrc || !item.isLocal"
      }],
      attrs: {
        "src": item.currentImgSrc,
        "height": "34"
      },
      on: {
        "error": function($event) {
          _vm.whenImageNotFound(id)
        }
      }
    }), _vm._v(" "), (item.isLocal) ? _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.validate),
        expression: "item.validate"
      }],
      staticClass: "input-file",
      class: item.class,
      attrs: {
        "data-qa": ("Content-ThemeForm-Upload-" + id),
        "id": item.name,
        "name": item.name,
        "accept": "image/*",
        "type": "file"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange(id, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.isLocal) ? _c('label', {
      staticClass: "el-button el-button--default",
      attrs: {
        "for": item.name
      }
    }, [_vm._v(_vm._s(_vm.$t('themeViewButtonUploadImageText')))]) : _vm._e(), _vm._v(" "), (item.isLocal) ? _c('div', {
      staticClass: "selected-file-name"
    }, [_vm._v(_vm._s(item.selectedFileName || _vm.$t('NoFileChosen')))]) : _vm._e(), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.isLocal),
        expression: "!item.isLocal"
      }],
      attrs: {
        "data-qa": ("Content-ThemeForm-Button-" + id)
      },
      on: {
        "click": function($event) {
          _vm.removeImage(id)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('themeViewButtonRemoveImageText')) + "\n        ")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "name": 'remove_' + id
      },
      domProps: {
        "value": item.isLocal ? id : ''
      }
    })], 1), _vm._v(" "), (_vm.errors.has(item.name)) ? _c('div', {
      staticClass: "help is-danger"
    }, [_vm._v("\n        " + _vm._s(_vm.errors.first(item.name)) + "\n      ")]) : _vm._e(), _vm._v(" "), (item.description) ? _c('div', {
      staticClass: "column-describe",
      attrs: {
        "data-qa": ("Content-ThemeForm-Description-" + id)
      }
    }, [_c('i', [_vm._v(_vm._s(_vm.$t(item.description)))])]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.data.text), function(item, id) {
    return _c('el-form-item', {
      key: id,
      attrs: {
        "data-qa": ("Content-ThemeForm-Item-" + id),
        "error": _vm.errors.has(id) ? _vm.errors.first(id) : '',
        "label": _vm.$t(item.label),
        "label-width": _vm.labelWidth,
        "show-message": _vm.errors.has(id)
      }
    }, [(_vm.isText(item.type) || _vm.isPassword(item.type)) ? _c('el-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.validate),
        expression: "item.validate"
      }],
      attrs: {
        "auto-complete": _vm.isPassword(item.type) ? 'new-password' : 'off',
        "data-qa": ("Content-ThemeForm-Input-" + id),
        "id": id,
        "name": id,
        "data-vv-as": _vm.$t(item.label),
        "placeholder": _vm.$t(item.placeholder) || '',
        "clearable": "",
        "type": item.type,
        "data-vv-validate-on": _vm.isPassword(item.type) ? 'change' : 'input|blur'
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isNumber(item.type)) ? _c('el-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.validate),
        expression: "item.validate"
      }],
      attrs: {
        "data-qa": ("Content-ThemeForm-Input-" + id),
        "id": id,
        "name": id,
        "data-vv-as": _vm.$t(item.label),
        "placeholder": _vm.$t(item.placeholder) || '',
        "clearable": "",
        "type": item.type
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", _vm._n($$v))
        },
        expression: "item.model"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isColorPicker(item.type)) ? _c('el-color-picker', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.validate),
        expression: "item.validate"
      }],
      attrs: {
        "data-qa": ("Content-ThemeForm-ColorPicker-" + id),
        "data-vv-as": _vm.$t(item.label),
        "id": id,
        "name": id,
        "placeholder": _vm.$t(item.placeholder),
        "popper-class": item.class
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isColorPicker(item.type)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.model),
        expression: "item.model"
      }],
      attrs: {
        "name": id,
        "type": "hidden"
      },
      domProps: {
        "value": (item.model)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "model", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isTextarea(item.type)) ? _c('el-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.validate),
        expression: "item.validate"
      }],
      class: item.class,
      attrs: {
        "data-qa": ("Content-ThemeForm-Textarea-" + id),
        "id": id,
        "name": id,
        "placeholder": _vm.$t(item.placeholder) || '',
        "rows": 20,
        "type": "textarea"
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }) : _vm._e(), _vm._v(" "), (item.description) ? _c('div', {
      staticClass: "column-describe",
      attrs: {
        "data-qa": ("Content-ThemeForm-Description-" + id)
      }
    }, [_c('i', [_vm._v(_vm._s(_vm.$t(item.description)))])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "btn-display-end",
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.saving || _vm.errors.any(),
      "loading": _vm.saving,
      "data-qa": "Content-ThemeForm-Button-Save",
      "native-type": "submit",
      "type": "warning"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('themeViewButtonSaveText')) + "\n      ")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6e18a30","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThemeView/ThemeView.vue
// module id = 988
// module chunks = 3